<template>
  <div class="single-column-content pa-5 ma-3">
    <page-title :title="'demo'"></page-title>
    <v-progress-circular
      indeterminate=""
      color="primary"
      v-if="loading"
    ></v-progress-circular>
  </div>
</template>

<script>
import userApi from '@/api/user'
import routes from '@/route_names'

export default {
  name: 'Demo',
  created: function() {
    this.submit()
  },
  data: function() {
    return {
      loading: true
    }
  },
  computed: {},
  methods: {
    submit: function() {
      const vm = this
      userApi.demo().then(function(data) {
        vm.$router.push({
          name: routes.APP
        })
      })
    }
  }
}
</script>

<style lang="stylus">
.single-column-content {
    width 500px
    text-align center
}
</style>
